export const AuthRoutes = {
  AUTH: '/auth',
  REGISTER: '/auth/register',
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgot-password',
  SET_PASSWORD: '/auth/reset-password/:id',
  RESEND_LINK: '/auth/resend-link',
};

export const AppRoutes = {
  HOME: '/home',
  MAP_PORTAL: '/services/map-portal',
  ALL_FILES: '/files/all-files',
  MAP_VIEW: '/services/map-portal/:id',
  MAP_PRINT: '/services/map-portal/:id/print',
  WORK_ORDERS: '/services/assetmanager/work-orders',
  SELECT_CLIENT: '/select-client',
  MY_PROFILE: '/my-profile',
  CLIENT_MANAGER: '/client-manager',
  USER_MANAGER: '/user-manager',
  GROUP_MANAGER: '/group-manager',
  /** Spatial dataset preview (US-109521) — temporary map environment */
  SPATIAL_PREVIEW: '/files/preview/:id',
  /** Legacy alias kept for existing bookmarks */
  SHAPEFILE_PREVIEW: '/files/shapefile/:id',
};
